import { useTranslation } from 'react-i18next'
import { Dialog } from '@machobear/design-system'
import { DialogEventHandler } from '@/types'
import NextStepsModalContent from './modal-content'

interface NextStepsModalProps {
  open: boolean
  listingId: string
  onClose: DialogEventHandler
}

const NextStepsModal = ({ open, onClose, listingId }: NextStepsModalProps) => {
  const { t } = useTranslation()

  return (
    <Dialog
      id="sponsoredListings"
      title={t('common.sponsored_listings', 'Sponsored Listings')}
      onClose={onClose}
      open={open}
    >
      <NextStepsModalContent listingId={listingId} />
    </Dialog>
  )
}

export default NextStepsModal
